<sh-auth-layout
  logoUrl="assets/shipm8-logo-reversed.svg"
  logoUrlOnLight="assets/shipm8-logo.svg"
  headline="auth.brand.headline"
  footer="auth.brand.footer"
>
  <sh-language-select authTopRight></sh-language-select>

  <form
    *ngIf="currentForm === 0"
    #loginForm="ngForm"
    (ngSubmit)="loginForm.submitted && loginForm.valid && login()"
    e2e-id="login-form"
  >
    <div>
      <h1 class="auth-title" e2e-id="login-logo">
        {{ 'auth.login.title' | translate }}
      </h1>
      <p class="auth-subline">{{ 'auth.login.subline' | translate }}</p>
    </div>
    <div class="auth-field">
      <label for="Username" e2e-id="username-label">{{
        'account.terms.username' | translate
      }}</label>
      <sh-input
        #username="ngModel"
        [(ngModel)]="loginModel.username"
        required
        inputId="Username"
        name="Username"
        type="text"
        icon="fa-solid fa-user"
        autocomplete="username"
        e2e-id="username-input"
      ></sh-input>
      <small
        *ngIf="
          loginForm.submitted && username.errors && username.errors['required']
        "
        class="error"
        e2e-id="username-required-error"
      >
        {{ 'account.login.error.usernameRequired' | translate }}
      </small>
    </div>
    <div class="auth-field">
      <label for="Password" e2e-id="password-label">{{
        'account.terms.password' | translate
      }}</label>
      <sh-password
        #password="ngModel"
        [(ngModel)]="loginModel.password"
        required
        inputId="Password"
        name="Password"
        icon="fa-solid fa-lock"
        e2e-id="password-input"
      ></sh-password>
      <small
        *ngIf="
          loginForm.submitted && password.errors && password.errors['required']
        "
        class="error"
        e2e-id="password-required-error"
      >
        {{ 'account.login.error.usernameRequired' | translate }}
      </small>
    </div>
    <sh-checkbox
      class="auth-check"
      [(ngModel)]="loginModel.rememberMe"
      inputId="RememberMe"
      name="RememberMe"
      label="account.login.rememberMe"
      e2e-id="remember-me-checkbox"
    ></sh-checkbox>
    <sh-message
      *ngIf="
        loginResponse &&
        !loginResponse.isSuccess &&
        loginResponse.isUnauthorized
      "
      severity="danger"
      text="account.login.error.incorrectUsernamePassword"
      e2e-id="unauthorized-error"
    ></sh-message>
    <sh-message
      *ngIf="
        loginResponse &&
        !loginResponse.isSuccess &&
        !loginResponse.isUnauthorized
      "
      severity="danger"
      text="account.login.error.general"
      e2e-id="general-error"
    ></sh-message>
    <div class="auth-actions">
      <sh-button
        type="submit"
        label="account.login.login"
        [loading]="isLoading"
        e2e-id="login-button"
      ></sh-button>
      <a href="https://shipm8.com/" class="auth-link" e2e-id="website-link">{{
        'account.login.website' | translate
      }}</a>
    </div>
  </form>

  <form
    *ngIf="currentForm === 2 && !redirecting"
    #mfaForm="ngForm"
    (ngSubmit)="sendVerificationCode(verificationCodeControl.value)"
    e2e-id="mfa-form"
  >
    <div class="auth-field">
      <label for="verificationCode" e2e-id="verification-code-label">
        {{ 'user.mfa.verificationCode.login' | translate }}
      </label>
      <sh-input
        #verificationCodeControl="ngModel"
        [(ngModel)]="verificationCode"
        required
        inputId="verificationCode"
        name="VerificationCode"
        autocomplete="one-time-code"
        e2e-id="verification-code-input"
      ></sh-input>
      <small
        *ngIf="
          mfaForm.submitted &&
          verificationCodeControl.errors &&
          verificationCodeControl.errors['required']
        "
        class="error"
        e2e-id="verification-code-required-error"
      >
        {{ 'user.mfa.verificationCodeRequired' | translate }}
      </small>
    </div>
    <div class="auth-actions">
      <sh-button
        type="submit"
        label="shared.terms.verify"
        [loading]="isLoading"
        e2e-id="verify-button"
      ></sh-button>
      <sh-button
        type="button"
        variant="text"
        label="shared.terms.backToLogin"
        (click)="currentForm = 0; redirecting = false"
        e2e-id="mfa-back-to-login-button"
      ></sh-button>
    </div>
  </form>

  <div
    *ngIf="currentForm === 3 && !redirecting"
    class="auth-form"
    e2e-id="mfa-setup-container"
  >
    <sh-mfa-setup #mfaSetup [setupCode]="mfaSetupCode"></sh-mfa-setup>
    <div class="auth-actions">
      <sh-button
        type="button"
        label="shared.terms.confirm"
        (click)="completeMfa()"
        e2e-id="confirm-mfa-button"
      ></sh-button>
      <sh-button
        type="button"
        variant="text"
        label="shared.terms.backToLogin"
        (click)="currentForm = 0; redirecting = false"
        e2e-id="mfa-setup-back-to-login-button"
      ></sh-button>
    </div>
  </div>

  <div *ngIf="redirecting" e2e-id="redirecting-message">
    <div class="auth-subline">
      {{ 'shared.terms.redirecting' | translate }}...
    </div>
  </div>
</sh-auth-layout>
